import { configureStore } from "@reduxjs/toolkit";
import displayReducer from './displaySlice';
import editsReducer from './editsSlice';
import apiReducer, { api } from './apiSlice'

const appStore = configureStore({
    reducer: {
        display: displayReducer, //for remembering display changes within a session
        edits: editsReducer, // for use when editing already uploaded content
        api: apiReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
        api.middleware
    ),
});

export default appStore;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof appStore.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof appStore.dispatch